import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { DetailModal } from '../../../components';
import styles from './style/index.less';
import DoctorHeader from './DoctorHeader';
var DoctorModal = function (_a) {
    var doctor = _a.doctor, show = _a.show, reportModuleParams = _a.reportModuleParams, currentTime = _a.currentTime, onHide = _a.onHide;
    var View = useComponents().View;
    return (React.createElement(DetailModal, { title: "\u533B\u751F\u8BE6\u60C5", className: styles['doctor-modal'], show: show, showReplay: true, currentTime: currentTime, onHide: onHide, reportModuleParams: reportModuleParams, height: 'calc(50% + 50px)' },
        React.createElement(DoctorHeader, { doctorData: doctor, isUnique: true, type: 'modal' }),
        React.createElement(View, { className: styles['doctor-modal-qualification'] },
            "\u8D44\u8D28\u6587\u4EF6\u7F16\u53F7\uFF1A",
            doctor.qualificationId),
        doctor.achievement && React.createElement(React.Fragment, null,
            React.createElement(View, { className: styles['doctor-modal-item-title'] }, "\u5B66\u672F\u6210\u5C31"),
            React.createElement(View, { className: styles['doctor-modal-item-content'] }, doctor.achievement)),
        doctor.award && React.createElement(React.Fragment, null,
            React.createElement(View, { className: styles['doctor-modal-item-title'] }, "\u8363\u8A89\u5956\u9879"),
            React.createElement(View, { className: styles['doctor-modal-item-content'] }, doctor.award)),
        doctor.award && doctor.awardDesc && React.createElement(React.Fragment, null,
            React.createElement(View, { className: styles['doctor-modal-item-title'] }, "\u8363\u8A89\u5956\u9879\u63CF\u8FF0"),
            React.createElement(View, { className: styles['doctor-modal-item-content'] }, doctor.awardDesc))));
};
export default DoctorModal;
